import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { ContentModule } from "./ContentModule";
var ContainerModule = function(param) {
    var id = param.id, modules = param.modules, renderCondition = param.renderCondition;
    var mods = Array.isArray(modules) ? modules : [
        modules
    ];
    return renderCondition ? /*#__PURE__*/ _jsx(UiLegacy.Card, {
        id: id,
        children: mods.map(function(module) {
            return /*#__PURE__*/ _jsx(ContentModule, _object_spread({}, module));
        })
    }) : null;
};
export { ContainerModule };
